import message from 'antd/es/message';
import 'antd/es/message/style';

export default message;
